import { StatusCredential } from "libLegacy/api/auth";
import { AlgaVariant } from "components/libComponents/AlgaTooltips/AlgaIcon";

type ScreenInfo = {
  text: string;
  buttonText?: string;
  navigateTo?: string;
};

/** Usage example:
 * `const { variant, monitoring: { text } } = STATUS_DATA[statusCredential]`
 * */
export type StatusDataModel = Record<
  Exclude<StatusCredential, "VALIDATED">,
  {
    variant: AlgaVariant;
    monitoring: ScreenInfo;
    billing: ScreenInfo;
  }
>;

const ERROR_DATA = {
  text: "Houve algo de errado com os seus dados. Verifique suas informações e tente novamente.",
  buttonText: "Preencher dados novamente",
};

export const STATUS_CREDENTIAL: Record<string, StatusCredential> = {
  VALIDATED: "VALIDATED",
  INVALIDATED: "INVALIDATED",
  PENDING: "PENDING",
  MISSING: "MISSING",
  UNSUPORTED: "UNSUPPORTED",
};

export const STATUS_DATA: StatusDataModel = {
  MISSING: {
    variant: "info",
    monitoring: {
      text: "Para ter a experiência completa com a Enermatch, preencha esses dados!",
      buttonText: "Preencher dados do inversor",
      navigateTo: "/onboarding/monitoring",
    },
    billing: {
      text: "Para ter a experiência completa com a Enermatch, preencha esses dados!",
      buttonText: "Preencher dados da concessionária",
      navigateTo: "/onboarding/energy-operator",
    },
  },
  PENDING: {
    variant: "success",
    monitoring: {
      text: "Estamos processando os seus dados. Em breve, as suas informações aparecerão aqui.",
    },
    billing: {
      text: "Estamos processando os seus dados. Em breve, as suas informações aparecerão aqui.",
    },
  },
  UNSUPPORTED: {
    variant: "info",
    billing: {
      text: "Colocamos você na lista de espera e te avisaremos assim que sua concessionária estiver disponível.",
    },
    monitoring: {
      text: "Colocamos você na lista de espera e te avisaremos assim que seu inversor estiver disponível. ",
    },
  },
  INVALIDATED: {
    variant: "error",
    monitoring: { ...ERROR_DATA, navigateTo: "/onboarding/monitoring" },
    billing: { ...ERROR_DATA, navigateTo: "/onboarding/energy-operator" },
  },
};
